import { ServicingState } from './reducer'

type RootState = { servicing: ServicingState }

export const getServicingRows = (state: RootState) => state.servicing.rows
export const getServicingLoader = (state: RootState) =>
  state.servicing.loading > 0
export const isServicingStale = (state: RootState) => state.servicing.stale
export const getServicingLoadError = (state: RootState) =>
  state.servicing.loadError
export const getServicingLastQuery = (state: RootState) =>
  state.servicing.lastQuery
export const getServicingPricing = (state: RootState) => state.servicing.pricing
